import React, { useState, useEffect } from "react";
// Chakra imports
import {
  Stat,
  StatLabel,
  StatNumber,
  Flex,
  Box,
  StatHelpText,
  Spacer,
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  Td,
  useColorModeValue,
  Progress,
  Button,
  useDisclosure,
  Icon,
  IconButton,
  Grid,
  SimpleGrid,
} from "@chakra-ui/react";
import { FaCircleNotch } from "react-icons/fa";

import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import IconBox from "components/Icons/IconBox";
// Custom icons
import {
  WalletIcon,
} from "components/Icons/Icons.js";
import InventoryClerksTable from "views/Custom/InventoryClerksTable";
import ToolsClerksTable from "views/Custom/ToolsClerksTable";
import MechanicsTable from "views/Custom/MechanicsTable";
import useGetCashTotal from "hooks/useGetCashTotal";
import CashesTable from "views/Custom/CashesTable";
import UsagesTable from "views/Custom/UsagesTable";

function PettyCash() {
  
  const iconTeal = useColorModeValue("teal.300", "teal.300");
  const iconBoxInside = useColorModeValue("white", "white");
  const textColor = useColorModeValue("gray.700", "white");

  let {
    totalCashes,
    gettingCashesTotal,
    setGettingCashesTotal,
    gettingCashesTotalReqSuccess
  } = useGetCashTotal({});

  
  const reloadTotal = () => {
    setGettingCashesTotal(true);
  }

  useEffect(() => {
    reloadTotal();
  }, []);

  return (
    <>
    <Flex direction="column" pt={{ base: "120px", md: "75px" }}>
      <SimpleGrid columns={{ sm: 1, md: 2, xl: 4 }} spacing="24px">
          <Card minH="83px">
            <CardBody>
              <Flex flexDirection="row" align="center" justify="center" w="100%">
                <Stat me="auto">
                  <StatLabel
                    fontSize="sm"
                    color="gray.400"
                    fontWeight="bold"
                    pb=".1rem"
                  >
                    Total Petty Cash
                  </StatLabel>
                  <Flex>
                    <StatNumber fontSize="lg" color={textColor}>
                      {!gettingCashesTotal && gettingCashesTotalReqSuccess 
                        ? `₱${Number(totalCashes).toLocaleString()}`
                        : 'Loading'
                      }
                    </StatNumber>

                    <IconButton 
                      ml="8px"
                      onClick={reloadTotal}
                      title="Reload Data"
                      icon={<Icon as={FaCircleNotch} me="4px" />} 
                    />
                  </Flex>
                </Stat>
                <IconBox as="box" h={"45px"} w={"45px"} bg={iconTeal}>
                  <WalletIcon h={"24px"} w={"24px"} color={iconBoxInside} />
                </IconBox>
              </Flex>
            </CardBody>
          </Card>
      </SimpleGrid>

          
      <Grid templateColumns={{ sm: "1fr", lg: "1.4fr 1.4fr" }}>
        
        <Box my={{ lg: "24px" }} me={{ lg: "24px" }}>
          <CashesTable 
            reloadTotal={reloadTotal}
          />   
  
        </Box>

        <Box my={{ lg: "24px" }} me={{ lg: "24px" }}>
          
          <UsagesTable 
            reloadTotal={reloadTotal}
          />

        </Box>
      </Grid>

    </Flex>
    
   

    </>
  );
}

export default PettyCash;
